import React from 'react';
import AllFilterButton from '../AllFilterButton/AllFilterButton';
import styles from './AllFilterCategory.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';

interface AllFilterCategoryProps {
  category: string;
  filters: { [key: string]: string };
  onFilterChange: (filterId: string) => void;
}

const AllFilterCategory: React.FC<AllFilterCategoryProps> = ({
  category,
  filters,
  onFilterChange,
}) => {
  const filterIds = Object.keys(filters);
  const [filteredFilterIds, setFilteredFilterIds] = React.useState<string[]>([]);

  const { activeFilters, availableAmenities } = useResultListContext();

  React.useEffect(() => {
    if (filteredFilterIds.length === 0) {
      const newFilteredFilterIds = filterIds.filter(id => availableAmenities[id]);
      
      if (!arraysAreEqual(newFilteredFilterIds, filteredFilterIds)) {
        setFilteredFilterIds(newFilteredFilterIds);
      }
    }
  }, [filterIds, availableAmenities, filteredFilterIds]);
  
  function arraysAreEqual(arr1:string[], arr2:string[]) {
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  }

  return (
    filteredFilterIds.length > 0 ? (
      <div className={styles.filter__category}>
        <h2 className={styles.filter__category__header}>{category}</h2>
        <div className={styles.filter__category__buttons}>
          {filteredFilterIds  .map((id) => (
            <AllFilterButton
              key={id}
              active={activeFilters[id]}
              id={id}
              label={filters[id]}
              onClick={onFilterChange}
            />
          ))}
        </div>
      </div>
    ) : null
  );
};

export default AllFilterCategory;
